import React, { useEffect, useState } from 'react';
import StyledBox from 'views/rebranded-module/information-module/ContactUsViewV2/ContactUsViewV2.styles';
import generateMetaData from 'lib/utils/generateMetaData';
import Head from 'next/head';
import { LazyLoad } from 'views/common/components';
import { Box, Container, Grid } from '@mui/material';
import {
  ContactUs,
  ContactUsSkeleton,
  AdditionalInformationSection,
  AdditionalInformationSectionSkeleton,
  FormSection,
  FormSectionSkeleton,
} from 'views/rebranded-module/information-module/ContactUsViewV2/components';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';
import { ImgBox } from 'views/rebranded-module/common/components';
import axios, { API } from 'lib/config/axios';
import useErrorsHandler from 'views/rebranded-module/common/hooks/useErrorsHandler';


interface ContactUsViewV2Props {
  serverData?: any;
}

const ContactUsViewV2: React.FC<ContactUsViewV2Props> = (props) => {
  const { serverData } = props;
  const cmsData = useContent();
  const handleErrorResponse = useErrorsHandler();
  const [contactUsData, setContactUsData] = useState(serverData);
  const getSizedImage = useAdabtiveMultiSizeImage();

  const getContactUsData = () => {
    axios
      .get(API.contactUs)
      .then((res) => {
        setContactUsData(res.data);
      })
      .catch((error) => {
        handleErrorResponse(error, false);
      });
  };
  useEffect(() => {
    if (!serverData) {
      getContactUsData();
    }
  }, []);
  return (
    <>
      {contactUsData?.seo_values && (
        <Head>{generateMetaData(contactUsData.seo_values)}</Head>
      )}
      <StyledBox>
        <Box className="CUHero">
          <Box className="CUHeroBGContainer">
            <ImgBox
              image={{
                src: getSizedImage(
                  cmsData.ContactUsPage.patternBackground.sizes,
                ),
                alt: cmsData.ContactUsPage.patternBackground.alt,
              }}
              width="100%"
              height="100%"
            />
          </Box>
          <Box className="CUHeroContent">
            <Container maxWidth="xl">
              <Box className="CUInner">
                <Grid container spacing={10}>
                  <Grid item lg={4.5} md={12} sm={12}>
                    <LazyLoad
                      skeleton={<ContactUsSkeleton />}
                      dataLoaded={!!contactUsData}>
                      <ContactUs phoneNumbers={contactUsData?.phone_numbers} />
                    </LazyLoad>
                  </Grid>
                  <Grid item lg={7.5} md={12} sm={12}>
                    <LazyLoad
                      skeleton={<FormSectionSkeleton />}
                      dataLoaded={!!contactUsData}>
                      <FormSection
                        leadCategories={contactUsData?.lead_categories}
                        leadTypes={contactUsData?.lead_types}
                        contactInfo={contactUsData?.contact_info}
                      />
                    </LazyLoad>
                  </Grid>
                </Grid>
              </Box>
            </Container>
          </Box>
        </Box>
        <LazyLoad
          skeleton={<AdditionalInformationSectionSkeleton />}
          dataLoaded>
          <AdditionalInformationSection />
        </LazyLoad>
      </StyledBox>
    </>
  );
};

export { ContactUsViewV2 };

